/* Authentication */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";

export const REGISTER_AUTHY_USER = "REGISTER_AUTHY_USER";
export const REGISTER_AUTHY_USER_SUCCESS = "REGISTER_AUTHY_USER_SUCCESS";
export const REGISTER_AUTHY_USER_ERROR = "REGISTER_AUTHY_USER_ERROR";

export const TEXT_AUTHY_OTP = "TEXT_AUTHY_OTP";
export const TEXT_AUTHY_OTP_SUCCESS = "TEXT_AUTHY_OTP_SUCCESS";
export const TEXT_AUTHY_OTP_ERROR = "TEXT_AUTHY_OTP_ERROR";

export const CALL_AUTHY_OTP = "CALL_AUTHY_OTP";
export const CALL_AUTHY_OTP_SUCCESS = "CALL_AUTHY_OTP_SUCCESS";
export const CALL_AUTHY_OTP_ERROR = "CALL_AUTHY_OTP_ERROR";

export const VERIFY_AUTHY_OTP = "VERIFY_AUTHY_OTP";
export const VERIFY_AUTHY_OTP_SUCCESS = "VERIFY_AUTHY_OTP_SUCCESS";
export const VERIFY_AUTHY_OTP_ERROR = "VERIFY_AUTHY_OTP_ERROR";

/* Reset Operations */
export const CREATE_PASSWORD_NOAUTH = "CREATE_PASSWORD_NOAUTH";
export const CREATE_PASSWORD_NOAUTH_SUCCESS = "CREATE_PASSWORD_NOAUTH_SUCCESS";
export const CREATE_PASSWORD_NOAUTH_ERROR = "CREATE_PASSWORD_NOAUTH_ERROR";

export const RESET_OPERATION_EMAIL_NOAUTH = "RESET_OPERATION_EMAIL_NOAUTH";
export const RESET_OPERATION_EMAIL_NOAUTH_SUCCESS =
  "RESET_OPERATION_EMAIL_NOAUTH_SUCCESS";
export const RESET_OPERATION_EMAIL_NOAUTH_ERROR =
  "RESET_OPERATION_EMAIL_NOAUTH_ERROR";

export const RESET_PHONE = "RESET_PHONE";
export const RESET_PHONE_SUCCESS = "RESET_PHONE_SUCCESS";
export const RESET_PHONE_ERROR = "RESET_PHONE_ERROR";
